import React from 'react'
import bg from "./../assets/bg.png";
import appleLogo from "./../assets/appleLogo.svg";
import googleLogo from "./../assets/googlePlayLogo.svg";
import phone from "./../assets/phone.png";
import { useLanguage } from '../config/language/LanguageContext';

const HeroSection = ({ id }) => {
  const { locale } = useLanguage();

  return (
    <section
      id={id}
      className="bg-gray-900 text-center pt-20 md:pt-28 rounded-3xl shadow-lg overflow-hidden"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="max-w-4xl mx-auto px-4 md:px-6 space-y-6">
        <h1 className="text-4xl md:text-5xl font-bold text-white">
          {locale.HERO.heroHeading}
        </h1>
        <p className="text-gray-300 mt-4 text-lg md:text-xl">
          {locale.HERO.heroParagraph}
        </p>

        <div className="flex gap-4 flex-col sm:flex-row justify-center items-center">
          {/* App Store */}
          <a
            href="https://apps.apple.com/ng/app/myqrmenu/id6745400220"
            className="flex items-center gap-3 px-3 py-2 border border-white rounded-lg bg-black text-white hover:scale-105 transition-transform"
          >
            <img
              src={appleLogo}
              alt="Phone Mockup"
              className="w-8 h-8"
            />
            <div>
              <p className="text-xs opacity-80 leading-none">
                {locale.HERO.downloadText}
              </p>
              <p className="text-xl font-semibold leading-none">
                {locale.HERO.appStore}
              </p>
            </div>
          </a>

          {/* Google Play */}
          <a
            href="https://play.google.com/store/apps/details?id=com.dastech.myqrmenu&pcampaignid=web_share"
            className="flex items-center gap-3 px-3 py-2 border border-white rounded-lg bg-black text-white hover:scale-105 transition-transform"
          >
            <div>
              <img
                src={googleLogo}
                alt="Phone Mockup"
                className="w-8 h-8"
              />
            </div>
            <div>
              <p className="text-xs opacity-80 leading-none">{locale.HERO.getItOn}</p>
              <p className="text-xl font-semibold leading-none">
                {locale.HERO.googlePlay}
              </p>
            </div>
          </a>
        </div>

        {/* <a
              href="https://form.typeform.com/to/fgpsBEja"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 bg-white text-gray-900 font-semibold px-8 py-3 rounded-full hover:bg-gray-200 transition inline-block text-center"
            >
              {locale.HERO.button}
            </a> */}
      </div>

      <div className="mt-12 relative max-w-3xl mx-auto px-4 h-[500px] overflow-hidden">
        <img
          src={phone}
          alt="Phone Mockup"
          className="mx-auto object-contain object-top w-full h-[600px] md:h-[650px] md:translate-y-20 scale-100 md:scale-110 transition-all duration-300"
        />
      </div>
    </section>
  )
}

export default HeroSection
